// Special characters like & makes the cursor jump back to the start.
// It works when we encode them.
const encodeHTMLEntities = (text = '') => {
  const textArea = document.createElement('textarea')
  textArea.innerText = text
  let encodedOutput = textArea.innerHTML
  const arr = encodedOutput.split('<br>')
  encodedOutput = arr.join('\n')
  return encodedOutput
}

// Make sure the variable labels are translated
const parseVariables = (
  value?: string | null,
  variables?: { key: string; value: string }[],
) => {
  return variables
    ? value?.replace(
        /<span[^>]+data-value="([^"]*)".*?>(.*?)<\/span>/g,
        (html: string, variableKey: string, variableLabel: string) =>
          html.replace(
            variableLabel,
            encodeHTMLEntities(
              variables.find(({ value }) => value === variableKey)?.key,
            )
              // æøå have to be encoded manually
              ?.replace(/æ/g, '&aelig;')
              ?.replace(/ø/g, '&oslash;')
              ?.replace(/å/g, '&aring;')
              ?.replace(/Æ/g, '&AElig;')
              ?.replace(/Ø/g, '&Oslash;')
              ?.replace(/Å/g, '&Aring;'),
          ),
      )
    : value
}

export default parseVariables
